<template>
  <b-modal id="bv-modal-price-list" size="md" centered
           :modal-class="{'modal-price-list-with-image': !!externalPriceListUrl}"
           :hide-header="!!externalPriceListUrl">
    <template #modal-title>
      <div class="d-block text-center">
        <h1 class="modal-title">
          {{ $t('pages.checkins_detail.label_price_list') }}
        </h1>
        <h4 class="modal-subtitle pt-2">
          {{ eventName }}
        </h4>
      </div>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('bv-modal-price-list')"></button>
    </template>

    <div v-if="externalPriceListUrl">
      <img :src="externalPriceListUrl" :alt="$t('pages.checkins_detail.label_price_list')" class="w-100">
    </div>

    <div class="d-block text-center" v-if="!externalPriceListUrl">
      <h6 class="pb-5" style="line-height: 1.5">{{
          $t('pages.checkins_detail.price_list_desc1')
        }}<br>{{ $t('pages.checkins_detail.price_list_desc2') }}</h6>

      <table class="table table-striped">
        <tbody>
        <tr v-for="item in priceListItems" :key="item.id">
          <template v-if="!onlyVideoPackagePrice">
            <td class="border-white text-left" v-if="item.quantity !== -2 || showVideoPackagePrice">
              <template v-if="item.quantity === -1">{{
                  $t('pages.checkins_detail.price_list_quantity_all_photos')
                }}
              </template>
              <template v-else-if="item.quantity === -2">
                <template v-if="onlyVideoPackagePrice">
                  {{ $t('pages.checkins_detail.price_list_quantity_all_video') }}
                </template>
                <template v-else>
                  {{ $t('pages.checkins_detail.price_list_quantity_all_photos_and_video') }}
                </template>
              </template>
              <template v-else-if="item.quantity > 0">{{
                  $tc('pages.checkins_detail.price_list_quantity', item.quantity)
                }}
              </template>
            </td>
            <td class="border-white text-right" v-if="item.quantity !== -2 || showVideoPackagePrice">
              <del v-if="item.price !== item.price_original" class="pr-2"> {{ item.price_original_formatted }}</del>
              <span :class="{'text-primary': item.price !== item.price_original}"> {{ item.price_formatted }} </span>
            </td>
          </template>
          <template v-else>
            <td class="border-white text-left" v-if="item.quantity === -2">
              {{ $t('pages.checkins_detail.price_list_quantity_all_video') }}
            </td>
            <td class="border-white text-right" v-if="item.quantity === -2">
              <del v-if="item.price !== item.price_original" class="pr-2"> {{ item.price_original_formatted }}</del>
              <span :class="{'text-primary': item.price !== item.price_original}"> {{ item.price_formatted }} </span>
            </td>
          </template>
        </tr>
        </tbody>
      </table>

      <div class="pb-3 text-primary h5" v-if="discountDescription">
        {{ discountDescription }}
      </div>

      <div class="text-left small px-2">
        {{ $t('pages.checkins_detail.note_price_list', {currencyName, currencySymbol}) }}
      </div>
    </div>

    <template slot="modal-footer">
      <div class="d-block mx-auto">
        <b-button variant="light" @click="$bvModal.hide('bv-modal-price-list')">
          {{ $t('pages.checkins_detail.close_btn_price_list') }}
        </b-button>
      </div>

    </template>
  </b-modal>
</template>

<script>
import {getBrowserLanguage} from "@/i18n";

export default {
  props: ['priceListItems', 'currency', 'discountDescription', 'eventName', 'showVideoPackagePrice', 'externalPriceListUrl', 'onlyVideoPackagePrice'],
  created() {
    this.locale = getBrowserLanguage()
  },
  methods: {
    getCurrency(currency, currencyDisplay) {
      return (0).toLocaleString(this.locale, {
        style: 'currency',
        currency: this.currency,
        currencyDisplay,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
          .replace(/\d/g, '').trim()
    }
  },
  computed: {
    currencySymbol() {
      // example: returns "€" for locale it and currency EUR
      return this.getCurrency('EUR', 'symbol')
    },

    currencyName() {
      // example: returns "euro" for locale it and currency EUR
      return this.getCurrency('EUR', 'name')
    }
  }
}
</script>
